import { render, staticRenderFns } from "./IndicatorResultPanel.vue?vue&type=template&id=af0706de"
import script from "./IndicatorResultPanel.vue?vue&type=script&lang=js"
export * from "./IndicatorResultPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports